// extracted by mini-css-extract-plugin
export var progressBar = "_la-0";
export var progressBarInner = "_la-1";